import { HttpService } from 'app/services';
import * as AppActions from 'app/store/actions';
import { parseError } from 'helpers/Error';

export const CREATE_ANNOUNCEMENT = '@ANNOUNCEMENT/CREATE';
export const CREATE_ANNOUNCEMENT_SUCCESS = '@ANNOUNCEMENT/CREATE_SUCCESS';
export const CREATE_ANNOUNCEMENT_FAIL = '@ANNOUNCEMENT/CREATE_FAIL';
export const CHANGE_ANNOUNCEMENT_CREATE_FORM = '@ANNOUNCEMENT/CHANGE_CREATE_FORM';
export const CLEAR_ANNOUNCEMENT_CREATE_FORM = '@ANNOUNCEMENT/CLEAR_CREATE_FORM';

const toAnnouncementPayload = (form = {}) => ({
  title: form.title?.trim(),
  content: form.content,
  startDate: form.startDate,
  endDate: form.endDate,
  status: form.status,
});

export const createAnnouncement = () => {
  return (dispatch, getState) => {
    const { announcementForm = {} } = getState().announcement.create;
    dispatch({ type: CREATE_ANNOUNCEMENT });
    return HttpService.post('/api/announcements/', toAnnouncementPayload(announcementForm))
      .then(() => {
        dispatch(AppActions.showMessage({ message: 'announcement:CREATE_SUCCESS' }));
        dispatch({ type: CREATE_ANNOUNCEMENT_SUCCESS });
        dispatch(AppActions.dataLoader_reload('GET:Announcements'));
      })
      .catch((err) => {
        const { errorFields, errorMessages, errorTitle } = parseError(err);
        dispatch({
          type: CREATE_ANNOUNCEMENT_FAIL,
          payload: { message: errorMessages.join('\n'), error: errorFields },
        });
        dispatch(AppActions.createDialogMessage('error', errorTitle, errorMessages));
      });
  };
};

export const changeAnnouncementCreateForm = (data) => ({
  type: CHANGE_ANNOUNCEMENT_CREATE_FORM,
  payload: { data },
});

export const clearAnnouncementCreateForm = () => ({
  type: CLEAR_ANNOUNCEMENT_CREATE_FORM,
});
